import React from 'react'
import ReactDOM from 'react-dom'
import './order-list.less'
import {
  Tabs,
  ListView,
  Toast,
  PullToRefresh,
  ActivityIndicator,
} from 'antd-mobile'
import Order from './order/order'
import { orderListApi } from '@/api/shopping-car'
import { setHeader } from '@/util/set-header'
import { withRouter } from 'react-router'
const APullToRefresh: any = PullToRefresh
const Footer = ({ isLoading, isHasMore, noHasMore }: any) => {
  if (!isHasMore) {
    return noHasMore || <div className="text-center">没有更多啦</div>
  }
  return (
    <div className="flex-lvc">
      {isLoading ? <ActivityIndicator text="加载中..." /> : ''}
    </div>
  )
}
@(withRouter as any)
class OrderList extends React.Component<any, any> {
  dataBlobs: any = {}
  sectionIDs = ['0']
  el!: ListView
  rowIDs: any = [[]]
  page = 1
  type = 'all'
  tabIndex = 0
  tabs = [
    { title: '全部订单' },
    { title: '待付款' },
    { title: '配货/配送' },
    { title: '已签收' },
    { title: '售后' },
  ]
  isHasMore = true
  constructor(props: any) {
    super(props)

    const getRowData = (dataBlob: any, sectionID: any, rowID: any) =>
      dataBlob[rowID]

    const dataSource = new ListView.DataSource({
      getRowData,
      rowHasChanged: (row1: any, row2: any) => row1 !== row2,
      sectionHeaderHasChanged: (s1: any, s2: any) => s1 !== s2,
    })

    this.state = {
      dataSource,
      isLoading: true,
      isRefreshing: false,
      height: (document.documentElement.clientHeight * 3) / 4,
    }
    this.tabChange=this.tabChange.bind(this)
    this.genData=this.genData.bind(this)
  }
  leftClick = () => {
    //返回App
    if (window.WebViewBridge) {
      window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge, 'canBack')
    } else if (window.webkit) {
      window.webkit.messageHandlers.navBackMarket.postMessage('canBack()')
    }
  }
  UNSAFE_componentWillMount() {
    setHeader({ title: '我的订单', leftClick: this.leftClick })
  }
  componentDidMount() {
    let { match } = this.props
    let tabIndex = Number(match.params.index)

    this.tabChange(this.tabs[tabIndex], tabIndex)
    window.canBack = this.canBack

    const height =
      document.documentElement.clientHeight -
      (ReactDOM.findDOMNode(this.el) as any).getBoundingClientRect().top
    this.setState({
      height,
    })
  }

  canBack = () => {
    this.props.history.push({ pathname: '/store' })
  }

  async genData(page = 1, type = 'all') {
    // Toast.loading('加载中', 0)
    const { data } = await orderListApi(type, page)
    // Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    const orderList = data.data
    if (orderList.length <= 0) {
      this.isHasMore = false
    }
    for (let i = 0; i < orderList.length; i++) {
      let { order_sn } = orderList[i]
      this.rowIDs[0].push(order_sn)
      this.dataBlobs[order_sn] = orderList[i]
    }
    this.setState({
      dataSource: this.state.dataSource.cloneWithRowsAndSections(
        this.dataBlobs,
        this.sectionIDs,
        this.rowIDs,
      ),
      isLoading: false,
    })
  }

  onEndReached = (event: any) => {
    if (this.state.isLoading || !this.isHasMore) {
      return
    }
    this.setState({ isLoading: true })
    this.page++
    this.genData(this.page, this.type)
  }
  tabChange(tab: any, index: number)  {
    const {genData} =this
    this.tabIndex = index
    this.page = 1
    this.rowIDs = [[]]
    this.dataBlobs = {}
    switch (index) {
      case 0:
        this.type = 'all'
        break
      case 1:
        this.type = 'confirmed'
        break
      case 2:
        this.type = 'payed'
        break
      case 3:
        this.type = 'finished'
        break
      case 4:
        this.type = 'finished'
        break
    }
    genData(this.page, this.type)
  }
  onRefresh = async () => {
    if (this.state.isLoading) {
      return
    }
    this.page = 1
    this.rowIDs = [[]]
    this.dataBlobs = {}
    this.setState({ isRefreshing: true, isLoading: true })
    await this.genData(this.page, this.type)
    this.setState({
      isRefreshing: false,
      isLoading: true,
    })
  }
  render() {
    const { isRefreshing, isLoading } = this.state
    const { isHasMore } = this
    const separator = (sectionID: any, rowID: any) => (
      <div
        key={`${sectionID}-${rowID}`}
        style={{
          backgroundColor: '#F5F5F9',
          height: 8,
          borderTop: '1px solid #ECECED',
          borderBottom: '1px solid #ECECED',
        }}
      />
    )

    return (
      <div>
        <Tabs
          tabs={this.tabs}
          page={this.tabIndex}
          useOnPan={false}
          distanceToChangeTab={3}
          onChange={(tab: any, index: number) => this.tabChange(tab, index)}
          renderTabBar={props => <Tabs.DefaultTabBar {...props} page={4} />}
        >
          <div className="order-list-view">
            <ListView
              ref={el => (this.el = el as ListView)}
              dataSource={this.state.dataSource}
              renderFooter={() => (
                <Footer isLoading={isLoading} isHasMore={isHasMore} />
              )}
              renderRow={order => <Order order={order} />}
              renderSeparator={separator}
              style={{ height: this.state.height, overflow: 'auto' }}
              onEndReached={this.onEndReached}
              pullToRefresh={
                <APullToRefresh
                  refreshing={isRefreshing}
                  onRefresh={this.onRefresh}
                />
              }
            />
          </div>
        </Tabs>
      </div>
    )
  }
}

export default OrderList
